import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './create_generic_tab.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import Edit from '../../../../../moreCore/UI/Edit/Edit';
import GenericDialog from '../../../../../moreCore/UI/GenericDialog/GenericDialog';
import lang from 'dojo/_base/lang';

class create_generic_tab extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private displayNameEdit: MdsLax<InstanceType<typeof Edit>>;

    private myDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    private val: { displayName: string, msTeamsChannelEntityId: string, tabId?:string } = null;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.displayNameEdit.setMaxLength(32);
        this.displayNameEdit.setLabel(this.translate("General_Label_Displayname"));
        this.displayNameEdit.on("valueChange", lang.hitch(this, this._onChange_DisplayText));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    private _onChange_DisplayText(ev:Event){
        let val:string = this.displayNameEdit.getValue();
        this.val.displayName = val;

        let filtered = val.replaceAll(" ", "");
        if (filtered != ""){
            if (filtered.length > 0){
                this.myDlg.enableButton('submit');
                return;
            }
        }
        this.myDlg.disableButton('submit');
    }
    public getValue() {
        return this.val;
    }

    public showAsDlg(msTeamsChannelEntityId: string, onSaveCallback?: Function,)
    {
        this.val = {displayName:"", msTeamsChannelEntityId:msTeamsChannelEntityId};

        if (this.myDlg != null){
            try{
                this.myDlg.destroyRecursive();
            }catch{}
        }
        this.myDlg = new GenericDialog();

        this.myDlg.setSize('smaller');
        this.myDlg.show(
            this,
            this.translate("MsTeamsIntegration_AdminPanel_TabConf_NewBtn"),
            null,
            null,
            'submitcancel',
            (res:number)=>{
                if (res == 1){
                    //submit
                    if (typeof onSaveCallback == 'function'){
                        onSaveCallback(this.getValue());
                    }
                }
            },
            null
        );
        this.myDlg.disableButton('submit');
    }

    public setUpEdit(entity: TeamsTabApiData) {
        this.displayNameEdit.setValue(entity.tabDisplayName, true);
        this.val.tabId = entity.ID;
    }
}

export default mdsWidget(create_generic_tab);
